export default "__VITE_ASSET__CjPdUGX7__"